(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 47805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(39641);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _layouts_pages_LoginLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87586);
/* harmony import */ var _signup_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21580);
/* harmony import */ var _signup_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_signup_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var Signup = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_pages_LoginLayout__WEBPACK_IMPORTED_MODULE_1__/* .LoginLayout */ .d, {
        title: "Sign up",
        displayLoginButton: true,
        officeNotice: true,
        displaySSO: false,
        googleBtnText: "Connect your Google work\xa0account",
        displayPreview: true,
        hideBanner: true,
        classes: {
            wrapper: (_signup_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper)
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "h1",
                className: (_signup_module_scss__WEBPACK_IMPORTED_MODULE_2___default().heading),
                children: "Welcome to Reclaim.ai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variant: "subtitle2",
                component: "p",
                className: (_signup_module_scss__WEBPACK_IMPORTED_MODULE_2___default().subtitle),
                children: "Create your free account — no credit card\xa0required"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Signup);


/***/ }),

/***/ 21580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"signup_wrapper__GNZDW","heading":"signup_heading__SA6qM","subtitle":"signup_subtitle__P8MsS"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5301,6886,9029,4216,3096,6305,9774,2888,179], function() { return __webpack_exec__(47805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);